module.exports = __webpack_public_path__ + "img/banner.5a57dad0.png";